import React from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import { Router, Route } from 'react-router-dom';
import Routes from './routes';
import store, { history } from './store/store';
import { Provider } from 'react-redux';
import './assets/css/bulma.min.css';
import './assets/css/styles.min.css';
import './assets/css/acervo.css';
import registerServiceWorker from "./registerServiceWorker";

const Root = ({ store }) => (
	<Provider store={store}>
		<Router history={history}>
			<Route children={Routes.props.children} />
		</Router>
	</Provider>
);

Root.propTypes = {
	store: PropTypes.object.isRequired
};

render(
	<Root store={store} />,
	document.getElementById('root')
);

console.log('%cProEquidad', 'color: #426858; font-weight:bold;font-size:2rem;');
console.log('%cPrograma ProEquidad', 'font-weight:bold;');
console.info('%cTodos los derechos reservados © 2019', 'color:#000000,font-size:1.4rem;');
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js